export const authQueryParams = {
  redirect: 'redirect',
}

export const authLoginPath = (redirectPath?: string) => {
  return `/__dev/login${redirectPath ? '?' + authQueryParams.redirect + '=' + encodeURI(redirectPath) : ''}`
}
export const authLogoutPath = () => '/__dev/logout'
